import { PALETTE, SIZES, MQ_TABLET} from '../../constants';
import { MediaQueryStyleSheet } from "react-native-responsive";

const borderColor = '#8d97aa';
const backgroundColor = '#0d1a35';

export default MediaQueryStyleSheet.create({

  paymentBtnBlock: {
    display: 'flex',
    justifyContent: 'flex-end',
    margin: 20
  },
   paymentStatusBtnBlock: {
    display: 'flex',
    justifyContent: 'flex-start',
    margin: 20,
    marginLeft:0
  },
    textHoldScreen: {
    fontSize:16,
  },
  confirmContainer: {
    paddingLeft: '10%', 
    paddingRight: '10%',
    paddingTop: 25 
  },
  paymentBtnTerminate: {
    display: 'flex',
    justifyContent: 'flex-end',
    margin: 20
  },
  paymentStatusBtnTerminate: {
    display: 'flex',
    justifyContent: 'flex-start',
    margin: 20,
    marginLeft:0
  },
    textHoldScreen: {
    fontSize:16,
    color: PALETTE.secondaryText
  },
  paymentTimer: {
    borderWidth: 2,
    borderColor: borderColor,
    borderRadius: 4,
    paddingHorizontal: 5,
    paddingVertical: 10,
    marginLeft: 10,
    backgroundColor: backgroundColor
  },
  pymtMobCnfrmStps:{
    marginTop:15
  },
  paymentNewRMrgn:{
    marginRight:10
  },
  cancelContainer:{
    padding: '12px 10px 12px 20px'
  },
   paymentBtnBlockReject: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: 20,
    
  },
});

export const selectedSVGStyles = {
  color: PALETTE.primaryText,
  radius: 4,
};